import { render, staticRenderFns } from "./export.vue?vue&type=template&id=5a205f8b&scoped=true"
import script from "./export.vue?vue&type=script&lang=js"
export * from "./export.vue?vue&type=script&lang=js"
import style0 from "./export.vue?vue&type=style&index=0&id=5a205f8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a205f8b",
  null
  
)

export default component.exports